import { IError, IScraperJobConfigurationHistoryItem } from 'types/graphqlTypes'
import { IScraperJobConfigurationFragment } from '../graphql/ScraperJobConfigurationFragment'
import { useUpdateScraperJobConfigurationsMutation } from '../graphql/UpdateScraperJobConfigurationsMutation'
import { TScraperJobConfigurationUpdateSchema } from '../schema/ScraperJobConfigurationUpdateSchema'

export interface IUpdateScraperJobResult {
  updateScraperJobHistories: Partial<IScraperJobConfigurationHistoryItem[]>[]
  updatedAt: string | undefined
  updateScraperJobResults: IScraperJobConfigurationFragment[]
  updateScraperJobLoading: boolean
  updateScraperJobErrors: IError[] | undefined
}

export const useUpdateScraperJob = () => {
  const [
    updateScraperJobConfigurationsMutation,
    { loading },
  ] = useUpdateScraperJobConfigurationsMutation()

  const update = async (
    formValues: TScraperJobConfigurationUpdateSchema,
    jobUuid: string
  ): Promise<IUpdateScraperJobResult> => {
    const { data } = await updateScraperJobConfigurationsMutation({
      variables: {
        input: { jobUuid, ...formValues },
      },
    })

    const { updateScraperJobConfigurations } = data || {}
    const { errors, updatedScraperJobConfigurationsAndHistories } =
      updateScraperJobConfigurations || {}

    const nodes: IScraperJobConfigurationFragment[] =
      updatedScraperJobConfigurationsAndHistories?.map(
        job => job.updatedScraperJobConfiguration as IScraperJobConfigurationFragment
      ) || []

    const histories: Partial<IScraperJobConfigurationHistoryItem[]>[] =
      updatedScraperJobConfigurationsAndHistories?.map(
        job =>
          job.updatedScraperJobConfigurationHistory?.scraperConfigurationHistory as Partial<
            IScraperJobConfigurationHistoryItem[]
          >
      ) || []

    const updatedAt = histories[0].slice(-1)[0]?.updatedAt
    return {
      updateScraperJobResults: nodes,
      updateScraperJobHistories: histories,
      updatedAt,
      updateScraperJobErrors: errors,
      updateScraperJobLoading: loading,
    }
  }

  return {
    update,
    loading,
  }
}
